var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-list',_vm._l((_vm.choices),function(item,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.label)+" - "+_vm._s(item.value)+" points")])],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6dea3be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/module/question/choice.vue
// module id = 398
// module chunks = 1